import Backbone from "backbone";
import _ from "underscore";

import {FloorPlanListView} from "./fp-list";
import {UnitListView} from "./unit-list";
import {DetailsView} from "./details";

let MainView = Backbone.View.extend({
    className: "tab-pane",
    id: "floorplans",
    attributes: {
        role: "tabpanel"
    },
    initialize: function(options) {
        let collection = options.collection;
        let opts = _.defaults({}, options, {
            floorPlan: null,
            unit: null,
            children: _.defaults(options.children || {}, {
                floorPlanListOptions: {},
                unitListOptions: {},
                detailsOptions: {}
            })
        });
        let apartmentTypeSettings = {
            apartmentType: opts.apartmentType,
            apartmentTypeLong: opts.apartmentTypeLong
        };

        this.setFloorPlan(opts.floorPlan);
        this.setUnit(opts.unit);

        let children = [
            "floorPlanListOptions",
            "unitListOptions",
            "detailsOptions"
        ];
        opts.children = _.mapObject(opts.children, (value, prop) => {
            if (_.contains(children, prop)) {
                value.collection = collection;
                value.floorPlan = this.floorPlan;
                value.unit = this.unit;
            }
            return value;
        });

        this.children = {
            fpList: new FloorPlanListView(_.extend(
                opts.children.floorPlanListOptions,
                apartmentTypeSettings)),
            unitList: new UnitListView(_.extend(
                opts.children.unitListOptions,
                apartmentTypeSettings)),
            details: new DetailsView(_.extend(
                opts.children.detailsOptions,
                apartmentTypeSettings))
        };

        this.children.fpList.on("tab", (tab) => this.tab(tab));
        this.children.unitList.on("tab", (tab) => this.tab(tab));
        this.children.details.on("tab", (tab) => this.tab(tab));

        this.firstRun = true;
    },
    render: function() {
        this.repeatForChildren("render");

        if (this.firstRun) {
            this.$el.append(this.children.fpList.el);
            this.$el.append(this.children.unitList.el);
            this.$el.append(this.children.details.el);
            this.firstRun = false;
        }

        this.delegateEvents();
        this.repeatForChildren("delegateEvents");
        return this;
    },
    tab: function(tab) {
        let {fpList, unitList, details} = this.children;
        let className = "active";

        switch (tab) {
            case "#fp_view_start":
                unitList.$el.removeClass(className);
                details.$el.removeClass(className);
                fpList.$el.addClass(className);
                break;
            case "#fp_view_units":
                details.$el.removeClass(className);
                fpList.$el.removeClass(className);
                unitList.$el.addClass(className);
                break;
            case "#fp_view_detailed":
                fpList.$el.removeClass(className);
                unitList.$el.removeClass(className);
                details.$el.addClass(className);
                break;
        }

        this.trigger("tabbed", tab);
    }
});

export {MainView};
